var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isLocal, isProd } from 'ziphy-web-shared/basic/helpers';
import { BaseService } from '../../baseService';
import { getFakeMock, marcosMock, selectsMock } from './___definitions.mock';
export class Definitions {
    constructor(props) {
        this.layouts = new DefinitionLayoutsService(props);
        this.macros = new DefinitionMacrosService(props);
        this.selects = new DefinitionSelectsService(props);
    }
}
/*
 * Definition Layouts
 */
class DefinitionLayoutsService extends BaseService {
    constructor(props) {
        super(props);
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.layouts.read', params, options);
            return res;
        });
    }
    list(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.layouts.list', params, options);
            if (!isProd()) {
                // if (!res.prepared?.items?.length) {
                //   res = await getFakeMock<T['ListResponse']>({ items: layoutsMock })
                // }
            }
            return res;
        });
    }
}
/*
 * Definition Macros
 */
class DefinitionMacrosService extends BaseService {
    constructor(props) {
        super(props);
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.macros.read', params, options);
            return res;
        });
    }
    list(params, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.macros.list', params, options);
            if (isLocal()) {
                if ((_a = res.prepared) === null || _a === void 0 ? void 0 : _a.items) {
                    // console.js('macros', res.prepared.items)
                    res.prepared.items = res.prepared.items.filter((x) => !['next_appointment', 'pcp_appointment'].includes(x.id));
                    res.prepared.items = res.prepared.items.concat(marcosMock);
                }
                else {
                    res = yield getFakeMock({ items: marcosMock });
                }
            }
            return res;
        });
    }
}
/*
 * Definition Selects
 */
class DefinitionSelectsService extends BaseService {
    constructor(props) {
        super(props);
    }
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.selects.read', params, options);
            return res;
        });
    }
    list(params, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.selects.list', params, options);
            if (!isProd()) {
                if ((_a = res.prepared) === null || _a === void 0 ? void 0 : _a.items) {
                    res.prepared.items = res.prepared.items.concat(selectsMock.filter((mockItem) => {
                        return !res.prepared.items.some((item) => item.id === mockItem.id);
                    }));
                }
            }
            return res;
        });
    }
    search(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('notes.selects.search', params, options);
            return res;
        });
    }
}
